import {AnyAction} from 'redux';

import * as at from './location_action_types';

export interface LocationState {
  parameters: Record<string, Record<string, any>>;
  query: Record<string, Record<string, any>>;
  nonQuery: Record<string, Record<string, any>>;
}

const defaultState: LocationState = {
  parameters: {},
  query: {},
  nonQuery: {},
};

function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    // v1
    case at.CHANGE_PARAMS: {
      const {params, pathName} = action.payload;
      return {
        ...state,
        parameters: {
          ...state.parameters,
          [pathName]: {
            ...state.parameters[pathName],
            ...params,
          },
        },
      };
    }
    // v2
    case at.CHANGE_QUERY: {
      const {key, query} = action.payload;
      return {
        ...state,
        query: {
          ...state.query,
          [key]: {
            ...query,
          },
        },
      };
    }
    case at.CHANGE_NON_QUERY: {
      const {key, nonQuery} = action.payload;
      return {
        ...state,
        nonQuery: {
          ...state.nonQuery,
          [key]: {
            ...nonQuery,
          },
        },
      };
    }
  }
  return state;
}

export default reducer;
